const useAddSearchParam = (url: string, key: string, value: string) => {
  if (!url || url?.length === 0) {
    return url;
  }

  const newUrl = new URL(url);
  if (!newUrl.searchParams.has(key)) {
    newUrl.searchParams.set(key, value);
  }
  return newUrl.toString();
};

export default useAddSearchParam;
